import { FC, useEffect } from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { Field } from "formik";
import { ImportRequestModel } from "../../../../models/ImportRequestModel";


type DetailProps = {
  detail?: ImportRequestModel
  editable?:boolean
  handleChangeDetail: (e: any) => void
  handleSubmit: () => void
  handleExportPdf: () => void
  handleExportCSV: () => void
}

const DetailInfo: FC<DetailProps> = ({
  detail, editable, 
  handleChangeDetail, 
  handleSubmit, 
  handleExportPdf,
  handleExportCSV
}) => {
  const intl = useIntl()
  
  useEffect(() => {
  })

  useEffect(() => {
  
  }, []);
 
  return (
    <div className="card-header py-4">
      <div className="col-md-12">
        <div className="row g-3 align-items-center">
          <div className="col-6 col-lg-2">
            <label 
              className="col-form-label">{intl.formatMessage({ id: 'WAREHOUSE.RECEIPT_CODE' })}</label>
          </div>
          <div className="col-6 col-lg-4">
            <strong>{detail?.code}</strong>
          </div>
          <div className="col-6 col-lg-2">
            <label
              className="col-form-label">Cửa hàng</label>
          </div>
          <div className="col-6 col-lg-4">
            { detail?.store?.name } <br/>
            { detail?.store?.address ?? ''}
          </div>
          <div className="col-12 col-lg-2">
            <label 
              className="col-form-label">Trạng thái</label>
          </div>
          <div className="col-12 col-lg-4">
            <select
              className="form-select"
              disabled={!editable}
              value={detail?.status}
              onChange={(e) => handleChangeDetail(e)}
              name="status"
            >
              <option value="new">Mới</option>
              <option value="preparing">Đang chuẩn bị</option>
              <option value="shipping">Đang giao hàng</option>
              <option disabled value="done">Hoàn thành</option>
              <option disabled value="cancel">Đã hủy</option>
            </select>
          </div>
          <div className="col-12 col-lg-2">
            <label 
              className="col-form-label">{intl.formatMessage({ id: 'WAREHOUSE.NOTE' })}</label>
          </div>
          <div className="col-12 col-lg-4">
            {detail?.note !== null && detail?.note !== '' && (
              <><strong>{detail?.store?.name}</strong>: {detail?.note ?? ''}</>
            )}
            <Field
                as='textarea'
                className="form-control"
                id="supplier_note"
                name="supplier_note"
                value={detail?.supplier_note || ''}
                onChange={(e: any) => handleChangeDetail(e)}
              />
          </div>
          <div className="btns-group">
            <button className="btn btn-primary mb-2 me-1" type="button" onClick={() => handleSubmit()}>Lưu</button>
            <Link to='/warehouse/receipt/import-requests' className="btn btn-primary mb-2 me-1">Quay lại</Link>
            <button className="btn btn-primary mb-2 me-1"
                type="button"
                onClick={() => handleExportPdf()}>{intl.formatMessage({id: 'ORDER.PRINT'})}
            </button>
            <button className="btn btn-primary mb-2 me-1"
                type="button"
                onClick={() => handleExportCSV()}>Tải xuống
            </button>
          </div>
        </div>
        {(detail?.is_incorrect_quality === 1 || detail?.is_incorrect_quantity === 1) && (
          <div className="row mt-3">
            <div className="d-flex">
              <label className='form-check form-check-sm form-check-custom form-check-solid ms-0'>
                  <input className='form-check-input'
                      type='checkbox' name='is_incorrect_quantity'
                      disabled={true}
                      checked={detail?.is_incorrect_quantity === 1}
                  />
                  <span className={detail?.is_incorrect_quantity === 1 ? 'form-check-label text-danger' : 'form-check-label'}>Giao thiếu</span>
              </label>
              <label className='form-check form-check-sm form-check-custom form-check-solid ms-3'>
                  <input className='form-check-input'
                      type='checkbox'
                      name='is_incorrect_quality'
                      disabled={true}
                      checked={detail?.is_incorrect_quality === 1}
                  />
                  <span className={detail?.is_incorrect_quality === 1 ? 'form-check-label text-danger' : 'form-check-label'}>Không đúng quy cách</span>
              </label>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
export default DetailInfo